/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import { useLocation } from "react-router";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";
import PersonalDataSummary from "./Summary/PersonalDataSummary";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import IncomeSummary from "./Summary/IncomeSummary";
import AssetsSummary from "./Summary/AssetsSummary";
import CostsSummary from "./Summary/CostSummary";
import { getCaseLink } from "@/src/services/productService";
import { useForm } from "@/src/provider/Form/FormProvider";
import Typography from "@mui/material/Typography";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Box } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

type SummaryProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
};

export default function Summary({ product, submitProps }: SummaryProps) {
  const location = useLocation();
  const stateField = location.state?.field;
  const { values, handleSubmit } = useForm();

  useEffect(() => {
    const el = document.getElementById(stateField);
    el && el.scrollIntoView();
  }, [stateField]);

  return (
    <>
      <ContentBox>
        <Typography variant={"h5"}>Ihre Angaben</Typography>
        <Grid container>
          <Box id={"personalDataSummary"} />
          <PersonalDataSummary formData={values} />
        </Grid>
        <Grid container>
          <Box id={"incomeSummary"} />
          <IncomeSummary formData={values} />
        </Grid>
        <Grid container>
          <Box id={"assetsSummary"} />
          <AssetsSummary formData={values} />
        </Grid>
        <Grid container>
          <Box id={"costsSummary"} />
          <CostsSummary formData={values} />
        </Grid>

        <form onSubmit={handleSubmit}>
          <FormSubmit
            sx={{ marginTop: "1rem" }}
            {...submitProps}
            hideBackButton={false}
            backLink={getCaseLink(product) + "/antrag/assistent"}
            backText={"Alles bearbeiten"}
            nextText={"Angaben speichern"}
            nextButtonSubtext={
              <small>
                <LockIcon sx={{ height: "12px", width: "12px", paddingTop: "2px" }} /> SSL-zertifiziert - Wir schützen Ihre Daten!
              </small>
            }
          />
        </form>
      </ContentBox>
    </>
  );
}
